import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Typography, Row } from '@copyrightagent/basic-components'
import { ICase, getFormatOccurredDate, ICaseLocation } from 'lib/entities/Case'
import { dark50 } from 'lib/Colors'

import { useStyle } from './style'

export interface Props {
	theCase: ICase
	caseLocation: ICaseLocation
}

const CaseLocation = ({ theCase, caseLocation }: Props): ReactElement => {
	const { t } = useTranslation()
	const classes = useStyle()

	const getStatusSubTitle = () => {
		const textWithDate = (text: string, date: string | null | undefined) => (
			<Row>
				<Typography>{text}</Typography>
				{date && (
					<Typography className={classes.caseStatusDate}>
						({getFormatOccurredDate(date, 'DD. MMMM YYYY')})
					</Typography>
				)}
			</Row>
		)

		if (theCase.state === 'pipedrive_won')
			return textWithDate(t('caseRow/labels/won'), theCase.won_at)
		if (theCase.state === 'pipedrive_lost')
			return textWithDate(t('caseRow/labels/closed'), theCase.lost_at)
		if (theCase.state === 'rejected')
			return textWithDate(t('caseRow/labels/closed'), null)
		if (theCase.state === 'client_approval') {
			return <Typography>{t('caseRow/labels/waitingForReview')}</Typography>
		}
		return <></>
	}

	const CreatedCaseColumn = () => (
		<Col>
			<Typography fontColor={dark50}>
				{theCase.created_at && getFormatOccurredDate(theCase.created_at)}
			</Typography>
			{/* TODO uncomment when status is updated as case is handled */}
			{/*<Typography className={classes.accentText} variant="body1">*/}
			{/*	{t('createCase/awaitingReview')}*/}
			{/*</Typography>*/}
		</Col>
	)

	const InReview = () => (
		<Col>
			<Typography fontColor={dark50}>
				{t('caseRow/defaultStatusTitle')}
			</Typography>
			{getStatusSubTitle()}
		</Col>
	)

	if (
		theCase.state === 'pipedrive_won' ||
		theCase.state === 'pipedrive_lost' ||
		theCase.state === 'rejected'
	)
		return <InReview />
	switch (caseLocation.type) {
		case 'createdCase':
			return <CreatedCaseColumn />
		default:
			return <InReview />
	}
}

export default CaseLocation
